export default (state) => ({
  ...state.customers.meta,
  total: Number(state.customers.meta.total),
  pages: Number(state.customers.meta.pages),
})
